(function (window, document) {
    var app = window.KombiApp = window.KombiApp || {};
    var isConsentInitialized = false;
    var preConsentDataLayer = [];

    // The consents need to be pushed to datalayer before we push event
    // We therefore cache the events in a separate array and then push these to the datalayer array wehn/if consent is given.
    window.addEventListener('CookieInformationConsentGiven', function (event) {
        isConsentInitialized = true;
        preConsentDataLayer.forEach(x => dataLayer.push(x));
    }, false);

    function pushToDatalayer(evt) {
        if (!isEventDisabled(evt.event)) {
            if (isConsentInitialized) {
                dataLayer.push(evt);
            }
            else {
                preConsentDataLayer.push(evt);
            }
            console.log(evt);
        }
    }

    function viewItemList(ecommerceObj) {
        if (!ecommerceObj) {
            return;
        }
        pushToDatalayer({ ecommerce: null });
        pushToDatalayer({
            event: "view_item_list",
            ecommerce: ecommerceObj
        });
    }

    function selectItem(ecommerceObj, item) {
        if (!ecommerceObj || !item) {
            return;
        }
        pushToDatalayer({ ecommerce: null });
        pushToDatalayer({
            event: "select_item",
            ecommerce: {
                item_list_id: ecommerceObj.item_list_id,
                item_list_name: ecommerceObj.item_list_name, 
                items: [item]
            }
        });
    }

    function beginCheckout(item) {
        if (!item) {
            return;
        }
        pushToDatalayer({ ecommerce: null });
        pushToDatalayer({
            event: "begin_checkout",
            ecommerce: {
                currency: "SEK",
                value: item.price,
                items: [item]
            }
        });
    }

    function addPaymentInfo(ecommerceObj, item, paymentType) {
        if (!ecommerceObj || !item || !paymentType) {
            return;
        }
        pushToDatalayer({ ecommerce: null });
        pushToDatalayer({
            event: "add_payment_info",
            ecommerce: {
                currency: "SEK",
                value: item.price,
                payment_type: paymentType,
                items: [item]
            }
        });
    }

    function purchase(paymentId, item, paymentType) {
        if (!paymentId || !item) {
            return;
        }

        // try to avoid to register a purchase event multiple times.
        if (!localStorage.getItem('gtm_purchase_payment_id_' + paymentId)) {
            pushToDatalayer({ ecommerce: null });
            pushToDatalayer({
                event: "purchase",
                ecommerce: {
                    transaction_id: paymentId,
                    value: item.price,
                    currency: "SEK",
                    items: [item],
                    payment_type: paymentType
                }
            });
            signUp(item.item_id)
            localStorage.setItem('gtm_purchase_payment_id_' + paymentId, 'true');
        }
        
    }

    function signUp(method) {
        if (!window.isUserAuthenticated) {
            pushToDatalayer({
                'event': 'sign_up',
                'method': method
            });
        }
    }

    function userLogin(userId, method) {
        if (!userId) {
            return
        }
        pushToDatalayer({
            'event': 'userLogin',
            'user_id': userId,
            'login_method': method
        });
    }

    function serverGeneratedEvent(evt) {
        if (!evt) {
            return;
        }
        pushToDatalayer(evt);
    }

    function isEventDisabled(eventName) {
        if (!eventName || !window.KombiApp.GTM.DisabledDatalayerEvents) {
            return false;
        }
        return window.KombiApp.GTM.DisabledDatalayerEvents.indexOf(eventName) !== -1;
    }
    var gtm = window.KombiApp.GTM = window.KombiApp.GTM || {};
    gtm.Ecommerce = {
        viewItemList: viewItemList,
        selectItem: selectItem,
        beginCheckout: beginCheckout,
        addPaymentInfo: addPaymentInfo,
        purchase: purchase
    };
    gtm.signUp = signUp;
    gtm.userLogin = userLogin;
    gtm.serverGeneratedEvent = serverGeneratedEvent;

})(window, document)